<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='1050px' top='10vh'>
    <el-form v-loading='formLoading' :model='form' label-width='140px' label-position='right'
             ref='ruleForm' class='p10 formHeight'>
      <div-border label='基础信息' class='p20'>
        <el-row :gutter='10'>
          <el-col :span='12'>
            <el-form-item label='委托商：'>
              <span>{{ form.consignorName |valFormat }}</span>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='品牌：'>
              <span>{{ form.brandName |valFormat }}</span>
            </el-form-item>
          </el-col>
        </el-row>
      </div-border>
      <div-border label='委托车列表' class='p20'>
        <el-form :model='searchForm' label-width='80px' ref='searchForm' :inline='true'>
          <el-form-item label='车架号：'>
            <el-input v-model='searchForm.frameNumber' size='mini' placeholder='请输入车架号' />
          </el-form-item>
          <el-form-item>
            <el-button size='small' style='margin-left: 10px;' class='searchBtn' @click='searchBtn'>
              查询
            </el-button>
            <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span='24' class='exportButton'>
            <span @click='exportData'>导出数据</span>
          </el-col>
        </el-row>
        <el-table
          ref='searchTable'
          row-key='id'
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          border
          max-height='400'
          :header-cell-style='headerCellStyle'>
          <el-table-column label='批次号' prop='batchNumber' align='center' width='160' />
          <el-table-column label='运单号' prop='waybillNo' align='center' width='180' />
          <el-table-column label='交单编号' prop='number' align='center' width='180' />
          <el-table-column label='车架号' prop='frameNumber' align='center' width='180' />
          <el-table-column label='品牌' prop='brandName' align='center' />
          <el-table-column label='型号' prop='modelName' align='center' />
          <el-table-column label='运输方式' prop='transportMode' align='center' :formatter='transportModeFormat'/>
          <el-table-column label='起运地' prop='arrivePlace' align='center' width='200' />
          <el-table-column label='目的地' prop='departurePlace' align='center' width='200' />
          <el-table-column label='运单类型' prop='waybillType' align='center' />
          <el-table-column label='状态' prop='status' align='center' :formatter='statusFormat' />
          <el-table-column label='供应商' prop='supplierName' align='center' width='200' />
          <el-table-column label='台账月' prop='settlementDate' align='center' />
          <el-table-column label='计划日期' prop='planDate' align='center' width='120' />
          <el-table-column label='交车日期' prop='deliveryDate' align='center' width='120' />
          <el-table-column label='交单日期' prop='surrenderDate' align='center' width='120' />
          <el-table-column label='交单人' prop='surrenderName' align='center' width='120' />
        </el-table>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          size='mini'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div-border>
    </el-form>
  </el-dialog>
</template>

<script>
  import divBorder from '@/components/divBorder.vue';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import { receiptReportDetailList } from '@/service/receipt';

  export default {
    name: 'deliveryReportInfo',
    components: { divBorder },
    data() {
      return {
        dialogTitle: '详情',
        dialogVisible: false,
        defaultForm: {},
        form: {},
        tableLoading: false,
        tableData: [],
        total: 0,
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        formLoading: false,
        searchForm: {
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
      };
    },
    filters: {
      valFormat(str) {
        if (str) {
          return str;
        } else {
          return '无';
        }
      },
    },
    methods: {
      statusFormat(r, c, cellValue) {
        switch (cellValue) {
          case '0':
            return '未交单';
          case '1':
            return '已交单';
        }
      },
      transportModeFormat(r, c, cellValue) {
        switch (cellValue) {
          case '1':
            return '公路';
          case '2':
            return '水路';
          case '3':
            return '水陆联运';
        }
      },
      // 导出数据
      exportData() {
        let token = getSessionStore('token');
        window.location.href = `${baseUrl}/platform/receiptManage/exportReceiptReportDetail?access_token=${token}&startTime=${this.searchForm.startTime}&endTime=${this.searchForm.endTime}&startPlanTime=${this.searchForm.startPlanTime}&endPlanTime=${this.searchForm.endPlanTime}&consignorId=${this.searchForm.consignorId}&brandId=${this.searchForm.brandId}&status=${this.searchForm.status}&frameNumber=${this.searchForm.frameNumber || ''}`;
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await receiptReportDetailList(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      dialogOpen(row, searchForm) {
        this.searchForm = {
          ...searchForm,
          consignorId: row.consignorId,
          brandId: row.brandId,
        };
        this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
        this.form = { ...row };
        this.dialogVisible = true;
        this.searchBtn();
      },
      dialogClose() {
        this.dialogVisible = false;
        this.tableData = [];
        this.total = 0;
      },
    },
  };
</script>

<style lang='scss' scoped></style>
